export default __webpack_public_path__ + "static/media/product-3.1c9d13cf.JPG";